module.exports = __webpack_public_path__ + "static/media/forge-builder.84fbe553.png";